module.exports = __webpack_public_path__ + "static/clay_golem-92086a71df0e66b68caa1e2bc57fee49.jpg";